import React, { Fragment } from 'react';

import {
  SkeletonText,
  Text,
  Tooltip,
  TooltipFocusableTrigger,
} from '@zapier/design-system';

import Link from 'app/common/components/Link';
import { useQueryPlatformVersions } from 'app/developer-v3/hooks';

type Props = {
  isCLI: boolean;
  platformVersion: string;
  version: string;
};

function PlatformVersionMessage({ isCLI, platformVersion, version }: Props) {
  const { data: platformVersions, isLoading } = useQueryPlatformVersions({
    staleTime: 600000,
  });
  const latestPlatformVersion = platformVersions?.[0]?.version;

  return isLoading ? (
    <SkeletonText lines={1} />
  ) : (
    <Text
      margin="0 0 20px"
      // We use a div instead of a p to avoid nesting a div (the TooltipFocusableTrigger) inside a p tag.
      // A div nested inside a p is not valid HTML.
      tag="div"
    >
      Version <strong>{version}</strong> is running on Platform{' '}
      <strong>
        {isCLI ? (
          platformVersion
        ) : (
          <Tooltip content={`The latest is ${latestPlatformVersion}.`}>
            {/* inline-block keeps the tooltip trigger (a div) from breaking the line */}
            <TooltipFocusableTrigger style={{ display: 'inline-block' }}>
              {platformVersion}
            </TooltipFocusableTrigger>
          </Tooltip>
        )}
      </strong>
      .
      {isCLI && platformVersion !== latestPlatformVersion && (
        <Fragment>
          {' '}
          The latest is <strong>{latestPlatformVersion}</strong>.
        </Fragment>
      )}{' '}
      See the{' '}
      <Link
        href="https://github.com/zapier/zapier-platform/blob/main/CHANGELOG.md"
        target="_blank"
      >
        changelogs
      </Link>{' '}
      for what’s new.
    </Text>
  );
}

export default PlatformVersionMessage;
